import { GetBodyCustomerImagesTabsQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerImagesTabs/getBodyCustomerImagesTabs.type';
import { getBodyCustomerImagesTabsQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerImagesTabs/getBodyCustomerImagesTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyCustomerImagesTabsOptions = (
  params: GetBodyCustomerImagesTabsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GET_BODY_CUSTOMER_IMAGE_TABS', params],
    queryFn: () => getBodyCustomerImagesTabsQueryFunction(params),
  });
};
